export const JEWELRY_BOXES = [
    {
      item: 'Camilla Luxury Jewelry Boxes',
      itemImageDesktop: '/images/packaging/jewelryBoxes/desktop/camilla.webp',
      //itemImageMobile: '/images/packaging/jewelryBoxes/mobile/camilla.webp',
      path: '/packaging/jewelry-boxes/camilla',
    },
    {
      item: 'Daria Luxury Jewelry Boxes',
      itemImageDesktop: '/images/packaging/jewelryBoxes/desktop/daria.webp',
      //itemImageMobile: '/images/packaging/jewelryBoxes/mobile/daria.webp',
      path: '/packaging/jewelry-boxes/daria',
    },
    {
      item: 'Valentina Luxury Jewelry Boxes',
      itemImageDesktop: '/images/packaging/jewelryBoxes/desktop/valentine.webp',
      //itemImageMobile: '/images/packaging/jewelryBoxes/mobile/valentine.webp',
      path: '/packaging/jewelry-boxes/valentina',
    },
    {
      item: 'Elena Luxury Jewelry Boxes',
      itemImageDesktop: '/images/packaging/jewelryBoxes/desktop/elena.webp',
      //itemImageMobile: '/images/packaging/jewelryBoxes/mobile/elena.webp',
      path: '/packaging/jewelry-boxes/elena',
    },
    {
      item: 'Vittoria Luxury Jewelry Boxes',
      itemImageDesktop: '/images/packaging/jewelryBoxes/desktop/vittoria.webp',
      //itemImageMobile: '/images/packaging/jewelryBoxes/mobile/vittoria.webp',
      path: '/packaging/jewelry-boxes/vittoria',
    },
    {
      item: 'Serena Luxury Jewelry Boxes',
      itemImageDesktop: '/images/packaging/jewelryBoxes/desktop/serena.webp',
      //itemImageMobile: '/images/packaging/jewelryBoxes/mobile/serena.webp',
      path: '/packaging/jewelry-boxes/serena',
    },
    {
      item: 'Ambra Luxury Jewelry Boxes',
      itemImageDesktop: '/images/packaging/jewelryBoxes/desktop/ambra.webp',
      //itemImageMobile: '/images/packaging/jewelryBoxes/mobile/ambra.webp',
      path: '/packaging/jewelry-boxes/ambra',
    },
    {
      item: 'Eleonora Luxury Jewelry Boxes',
      itemImageDesktop: '/images/packaging/jewelryBoxes/desktop/eleonora.webp',
      //itemImageMobile: '/images/packaging/jewelryBoxes/mobile/eleonora.webp',
      path: '/packaging/jewelry-boxes/eleonora',
    },
    {
      item: 'Stella Luxury Jewelry Boxes',
      itemImageDesktop: '/images/packaging/jewelryBoxes/desktop/stella.webp',
      //itemImageMobile: '/images/packaging/jewelryBoxes/mobile/stella.webp',
      path: '/packaging/jewelry-boxes/stella',
    },
  ]